document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".videos-slider");
  if (!sections.length || typeof Swiper === "undefined") return;

  sections.forEach((section) => {
    const swiperEl = section.querySelector(".swiper");
    if (!swiperEl) return;

    const slidesPerViewDesktop =
      parseFloat(section.dataset.slidesPerViewDesktop) || 1;
    const slidesPerViewMobile =
      parseFloat(section.dataset.slidesPerViewMobile) || 1;
    const spaceBetween = parseInt(section.dataset.spaceBetween, 10) || 24;

    const swiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: slidesPerViewMobile,
      spaceBetween: spaceBetween,
      breakpoints: {
        750: {
          slidesPerView: 1,
          spaceBetween: spaceBetween,
        },
        990: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: spaceBetween,
        },
      },
    });

    const prevButtons = section.querySelectorAll(".videos-slider__prev");
    const nextButtons = section.querySelectorAll(".videos-slider__next");

    prevButtons.forEach((button) => {
      button.addEventListener("click", () => swiper.slidePrev());
    });

    nextButtons.forEach((button) => {
      button.addEventListener("click", () => swiper.slideNext());
    });

    const videos = Array.from(
      section.querySelectorAll(".videos-slider__video-el")
    );

    const setButtonState = (button, isPlaying) => {
      if (!button) return;
      button.classList.toggle("is-playing", isPlaying);
      button.setAttribute(
        "aria-label",
        isPlaying ? "Pause video" : "Play video"
      );
    };

    const pauseVideo = (video) => {
      if (!video) return;
      video.pause();
      const media = video.closest(".videos-slider__media");
      const button = media ? media.querySelector("[data-video-toggle]") : null;
      setButtonState(button, false);
    };

    const pauseAllVideos = (exceptVideo) => {
      videos.forEach((video) => {
        if (video !== exceptVideo) {
          pauseVideo(video);
        }
      });
    };

    const playVideo = (video) => {
      if (!video) return;
      const media = video.closest(".videos-slider__media");
      const button = media ? media.querySelector("[data-video-toggle]") : null;
      pauseAllVideos(video);
      const playPromise = video.play();
      setButtonState(button, true);
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {
          setButtonState(button, false);
        });
      }
    };

    const getActiveVideo = () => {
      const activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return null;
      return activeSlide.querySelector(".videos-slider__video-el");
    };

    videos.forEach((video) => {
      video.pause();
      video.muted = true;
      video.volume = 1;
      video.addEventListener("ended", () => {
        const media = video.closest(".videos-slider__media");
        const button = media
          ? media.querySelector("[data-video-toggle]")
          : null;
        setButtonState(button, false);
      });
    });

    const toggleButtons = section.querySelectorAll("[data-video-toggle]");
    toggleButtons.forEach((button) => {
      setButtonState(button, false);
      button.addEventListener("click", () => {
        const media = button.closest(".videos-slider__media");
        const video = media
          ? media.querySelector(".videos-slider__video-el")
          : null;
        if (!video) return;

        if (video.paused) {
          playVideo(video);
        } else {
          video.pause();
          setButtonState(button, false);
        }
      });
    });

    swiper.on("slideChange", () => {
      pauseAllVideos();
    });

    swiper.on("slideChangeTransitionEnd", () => {
      playVideo(getActiveVideo());
    });

    playVideo(getActiveVideo());
  });
});
